import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const HomeIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M10 9c0-.6.4-1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1Z" />
    <path
      fillRule="evenodd"
      d="M12.7 2.2a1 1 0 0 0-1.4 0l-7 6-2.5 2.2A1 1 0 1 0 3.2 12l.8-.7V21c0 .6.4 1 1 1h14c.6 0 1-.4 1-1v-9.8l.7.6a1 1 0 1 0 1.3-1.5l-2.3-2-.7-.6V4a1 1 0 1 0-2 0v2l-4.3-3.8ZM18 20V9.5L12.8 5l-.2-.1-.6-.6-.7.6-.1.2L6 9.5V20h3v-7c0-.6.4-1 1-1h4a1 1 0 0 1 1 1v7h3Zm-5 0v-6h-2v6h2Z"
      clipRule="evenodd"
    />
  </Icon>
));
export default HomeIcon;
